import flatpickr from 'flatpickr';
import {Poland} from 'flatpickr/dist/l10n/pl.js';
flatpickr.localize(Poland);

export const dateTimePicker = (() => {
  const parseBool = (val) => val === 'true' || val === '1' || val === true || val === 1;

  const parseDateConfig = (el) => {
    const config = {
      locale: 'pl'
    };
    const d = el.dataset;

    if (parseBool(d.static)) config.static = true;
    if (d.dateFormat) config.dateFormat = d.dateFormat;
    if (parseBool(d.enableTime)) config.enableTime = true;
    if (parseBool(d.enableTime) && d.dateFormat) config.dateFormat = `${d.dateFormat} H:i`;
    if (d.altFormat) {
      config.altInput = true;
      config.altFormat = d.altFormat;
    }
    if (d.minDate) config.minDate = d.minDate;
    if (d.maxDate) config.maxDate = d.maxDate;
    if (d.defaultDate) config.defaultDate = d.defaultDate;
    if (parseBool(d.multipleDate)) config.mode = 'multiple';
    if (parseBool(d.rangeDate)) config.mode = 'range';
    if (parseBool(d.inlineDate)) {
      config.inline = true;
      if (d.defaultDate) config.defaultDate = d.defaultDate;
    }
    if (d.disableDate) config.disable = d.disableDate.split(',');
    if (parseBool(d.weekNumber)) config.weekNumbers = true;

    return config;
  };

  const parseTimeConfig = (el) => {
    const config = {
      enableTime: true,
      noCalendar: true,
      dateFormat: 'H:i',
    };

    const d = el.dataset;

    if (parseBool(d.timeHrs)) config.time_24hr = true;
    if (d.minTime) config.minTime = d.minTime;
    if (d.maxTime) config.maxTime = d.maxTime;
    if (d.defaultTime) config.defaultDate = d.defaultTime;
    if (parseBool(d.timeInline)) config.inline = true;

    return config;
  };

  return {
    init() {
      document.querySelectorAll('[data-date-provider]').forEach((el) => {
        const type = el.dataset.dateProvider;
        const config = type === 'flatpickr' ? parseDateConfig(el) : parseTimeConfig(el);
        flatpickr(el, config);
      });
    },
  };
})();

export default dateTimePicker;
